const SkeletonLine = ({ className = "" }) => (
  <div className={`animate-pulse rounded-full bg-slate-200 ${className}`} />
);

const SkeletonContactRow = ({ wide = false }) => (
  <div className="flex items-center rounded-xl bg-slate-50 p-4">
    <div className="h-10 w-10 shrink-0 animate-pulse rounded-lg bg-cyan-100" />
    <div className="ml-4 min-w-0 flex-1 space-y-2">
      <SkeletonLine className="h-3 w-20" />
      <SkeletonLine className={`h-4 ${wide ? "w-52" : "w-36"}`} />
    </div>
    <div className="h-5 w-5 animate-pulse rounded-full bg-slate-200" />
  </div>
);

const Loader = () => (
  <div
    data-testid="loader"
    aria-label="Caricamento card"
    className="min-h-screen w-full bg-[#f2f4f7] p-4"
  >
    <div className="mx-auto flex min-h-screen max-w-md items-center">
      <div className="w-full overflow-hidden rounded-2xl bg-white shadow-lg">
        <div className="relative bg-gradient-to-r from-[#1b8395] to-[#20acad] px-6 pb-8 pt-8 text-center">
          <div className="absolute right-4 top-4 h-10 w-10 animate-pulse rounded-full bg-white/20" />
          <div className="mx-auto mb-3 h-16 w-16 animate-pulse rounded-full bg-white/25 ring-2 ring-white/25" />
          <div className="mx-auto h-6 w-48 animate-pulse rounded-full bg-white/35" />
          <div className="mx-auto mt-3 h-4 w-32 animate-pulse rounded-full bg-white/25" />
          <div className="mt-5 flex justify-center gap-3">
            <div className="h-8 w-8 animate-pulse rounded-full bg-white/20" />
            <div className="h-8 w-8 animate-pulse rounded-full bg-white/20" />
            <div className="h-8 w-8 animate-pulse rounded-full bg-white/20" />
          </div>
        </div>

        <div className="px-6 pt-6">
          <div className="mb-6 flex gap-3">
            <div className="h-14 flex-1 animate-pulse rounded-xl bg-cyan-100" />
            <div className="h-14 w-12 animate-pulse rounded-xl bg-slate-100" />
            <div className="h-14 w-12 animate-pulse rounded-xl bg-slate-100" />
          </div>

          <SkeletonLine className="mb-4 h-5 w-44 bg-cyan-100" />
          <div className="mb-8 space-y-3">
            <SkeletonContactRow wide />
            <SkeletonContactRow />
            <SkeletonContactRow />
          </div>

          <SkeletonLine className="mb-4 h-5 w-40 bg-cyan-100" />
          <div className="space-y-3 pb-6">
            <SkeletonContactRow wide />
            <SkeletonContactRow />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Loader;
